import { captureException } from '@sentry/react'
import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { GetListParams } from 'react-admin'
import { isEmpty } from '../../../utils/isEmpty'

const REQUEST_PATH = '/partners/vendor/products'

type GetProductsResponse = {
  products: Array<{
    id: string
    name: string
    total_items_count: number
  }>
  total_entries: number
  has_batches_regardless_filters?: boolean
}

export const getProducts = async (params: GetListParams) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { get } = StackAPI()

  const page = params.pagination?.page || 1

  try {
    const response = await get<GetProductsResponse>({
      path: REQUEST_PATH,
      params: { page }
    })

    return response.data
  } catch (error) {
    captureException(error, { extra: { role } })
    return { error: 'unknown error' }
  }
}
